import { FileDto } from '../common/interfaces/infoboard.interface';
import { ReactComponent as NonImageIcon } from '../assets/no-image-icon.svg';
import { ReactComponent as DownloadIcon } from '../assets/import-icon.svg';
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';

import { palette } from '../theme';
interface GenericFileProps {
  file: FileDto;
}

const GenericFile: React.FC<GenericFileProps> = ({ file }) => {
  const isMedia = !!file.thumbnail;

  const handleOpen = () => {
    window.open(file.presignedUrl, '_blank', 'noopener,noreferrer');
  };

  const handleDownload = async () => {
    if (!file.presignedUrl) return;
    try {
      const response = await fetch(file.presignedUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name || `file.${file.extension}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed', err);
    }
  };

  return (
    <Box
      sx={{
        width: 100,
        borderRadius: '10px',
        border: `1px solid ${palette.line}`,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '58px',
          backgroundColor: file.thumbnail ? palette.surface.hover : palette.lavender.soft,
          position: 'relative',
          display: 'flex',
          justifyContent: file.thumbnail ? 'center' : 'flex-start',
          alignItems: file.thumbnail ? 'center' : 'flex-end',
          padding: file.thumbnail ? 0 : '0 0 8px 8px',
          cursor: 'pointer'
        }}
        onClick={handleOpen}
      >
        {file.thumbnail ? (
          <img src={file.thumbnail || file.filePath} alt={file.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <NonImageIcon
            style={{
              width: 28,
              height: 28
            }}
          />
        )}
      </Box>
      {isMedia ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
            padding: '4px 6px',
            color: palette.text.secondary
          }}
        >
          <Typography
            sx={{
              color: palette.sidebar.textMuted,
              fontSize: 12
            }}
          >
            {file.extension.toUpperCase()}
          </Typography>
          <IconButton onClick={handleDownload} size="small" sx={{ padding: 0 }}>
            <DownloadIcon width={24} height={24} />
          </IconButton>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'center',
            padding: '4px 6px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: 12,
                maxWidth: 90,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {file.name}
            </Typography>
            <IconButton onClick={handleDownload} size="small" sx={{ padding: 0 }}>
              <DownloadIcon width={24} height={24} />
            </IconButton>
          </Box>
          <Typography sx={{ color: palette.sidebar.textMuted, fontSize: 12 }}>{file.extension.toUpperCase()}</Typography>
        </Box>
      )}
    </Box>
  );
};
export default GenericFile;
